// extracted by mini-css-extract-plugin
export default {"biography__title":"Biography_biography__title__WZkxE","biography__description":"Biography_biography__description__A4lU5"};